import { DateTime } from 'luxon'

import getSessionEndDate from './getSessionEndDate'

export default function sessionTimeLocalToRemote({
  time,
  date,
  duration,
}: {
  time: string
  date: string
  duration: string
}): {
  start: Date
  end: Date
} {
  const timeMinutes = Number.parseFloat(`${time}`) * 60

  const plusHours = Math.floor(timeMinutes / 60)
  const plusMinutes = timeMinutes % 60
  const startDate = DateTime.fromISO(date)
    .startOf('day')
    .set({
      hour: plusHours,
      minute: plusMinutes,
    })
    .toJSDate()

  return {
    start: startDate,
    end: getSessionEndDate({
      startDate,
      durationMinutes: Number.parseInt(duration, 10),
    }),
  }
}
